<template>
    <div class="container">
        <div
            v-if="!hasPerson || user.submitting"
            class="row mb"
            data-qa="person-loading"
        >
            <div class="col-12">
                <h2>{{ t('Profile.Security.Section2FA.Headline') }}</h2>
            </div>
            <div class="col-12 col-md-12 col-lg-8 text-align--center">
                <p>{{ t('General.IsLoading') }}</p>
                <CrefoRingLoading />
            </div>
        </div>
        <div v-else>
            <div class="row">
                <div class="col-12">
                    <h2>{{ t('Profile.Security.Section2FA.Headline') }}</h2>

                    <div v-if="!isMfaActivated()">
                        <p>{{ t('Profile.Security.Section2FA.Subline') }}</p>

                        <h3 class="mt">{{ t('Profile.Security.Section2FA.AUTHENTICATOR_APP.Headline') }}</h3>
                        <p>{{ t(`Profile.Security.Section2FA.AUTHENTICATOR_APP.CodeGeneration`) }}</p>
                        <div class="mb">
                            <a
                                href="#"
                                class="link-icon-next"
                                data-qa="activate-authenticator-app-link"
                                @click.prevent="configureOTP(mfaMethods.authenticator.action, getLanguage())"
                            >
                                <span>{{ t(`Profile.Security.Section2FA.Activate`) }}</span>
                            </a>
                        </div>

                        <h3 class="mt">{{ t('Profile.Security.Section2FA.EMAIL.Headline') }}</h3>
                        <p>{{ t(`Profile.Security.Section2FA.EMAIL.CodeGeneration`) }}</p>
                        <p>{{ t(`Profile.Security.Section2FA.EMAIL.ActivateText`) }}</p>
                        <div class="mb">
                            <a
                                href="#"
                                class="link-icon-next"
                                data-qa="activate-email-link"
                                @click.prevent="configureOTP(mfaMethods.email.action, getLanguage())"
                            >
                                <span>{{ t(`Profile.Security.Section2FA.Activate`) }}</span>
                            </a>
                        </div>
                    </div>

                    <div v-else class="mt">
                        <h3>
                            <i
                                class="crefo-brand-icon icon-check-circle text-brand-blue"
                                style="margin-right: 5px"
                                aria-hidden="true"
                            />
                            {{ t(`Profile.Security.Section2FA.Active`) }}
                        </h3>

                        <div v-if="isMethodActivated(mfaMethods.authenticator.type)">
                            <p>{{ t(`Profile.Security.Section2FA.AUTHENTICATOR_APP.CodeGeneration`) }}</p>
                            <div class="mb">
                                <a
                                    href="#"
                                    class="link-icon-next text-brand-red"
                                    data-qa="deactivate-otp-link"
                                    @click.prevent="removeOTP(getCredentialId(mfaMethods.authenticator.type), getLanguage())"
                                >
                                    <span>{{ t('Profile.Security.Section2FA.Deactivate') }}</span>
                                </a>
                            </div>
                        </div>
                        <div v-else-if="isMethodActivated(mfaMethods.email.type)">
                            <p>{{ t(`Profile.Security.Section2FA.EMAIL.CodeGeneration`) }}</p>
                            <div class="mb">
                                <a
                                    href="#"
                                    class="link-icon-next text-brand-red"
                                    data-qa="deactivate-otp-link"
                                    @click.prevent="removeOTP(getCredentialId(mfaMethods.email.type), getLanguage())"
                                >
                                    <span>{{ t('Profile.Security.Section2FA.Deactivate') }}</span>
                                </a>
                            </div>
                            <p>{{ t(`Profile.Security.Section2FA.EMAIL.Upgrade`) }}</p>
                            <a
                                href="#"
                                data-qa="upgrade-otp-link"
                                class="link-icon-next"
                                @click.prevent="configureOTP(mfaMethods.authenticator.action, getLanguage())"
                            >
                                <span>{{ t('Profile.Security.Section2FA.EMAIL.UpgradeLink') }}</span>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import { useI18n } from 'vue-i18n'
import { onMounted } from 'vue'
import CrefoRingLoading from '@/components/helper/ring-loading'
import getLanguage from '@/helper/language'
import { configureOTP, removeOTP } from '@/services/keycloak-service'
import { useUserStore } from '@/store/module-user.js'
import { storeToRefs } from 'pinia'
import mfaMethods from '@/helper/mfaMethods.js'

const { t } = useI18n()
const store = useUserStore()
const {
    getUser: user,
    hasPerson,
    getMFACredentials,
} = storeToRefs(store)

onMounted(() => {
    store.getPersonMeMFACredentials()
})

const isMfaActivated = () => {
    return getMFACredentials.value.length > 0
}

const isMethodActivated = (type) => {
    return getMFACredentials.value.some(cred => cred.type === type)
}

const getCredentialId = (type) => {
    const foundCredential = getMFACredentials.value.find(cred => cred.type === type)
    return foundCredential?.credentialId || ''
}
</script>

<style>

h2,h3,h4 {
    margin-bottom: 10px !important;
}

</style>
